export const layout = {
  HEB: {
    // Profile dropdown
    subscription: "ניהול חשבון",
    contact: "צור קשר / סיוע",
    manageConnections: "ניהול חיבורי בנקאות",
    familyAccount: "חשבון משפחתי",
    biometricSetup: "הגדרת זיהוי ביומטרי",
    biometricManage: "ניהול זיהוי ביומטרי",
    biometricEnabled: "זיהוי ביומטרי פעיל ✓",
    biometricModalTitle: "ניהול זיהוי ביומטרי",
    biometricAddDevice: "הוספת מכשיר",
    biometricRemove: "הסרה",
    biometricThisDevice: "(מכשיר זה)",
    biometricNoDevices: "אין מכשירים מחוברים",
    biometricConfirmRemove: "האם להסיר את הזיהוי הביומטרי ממכשיר זה?",
    biometricRegistering: "רושם...",
    biometricRegisterSuccess: "הזיהוי הביומטרי הוגדר בהצלחה למכשיר זה!",
    biometricNotSupported: "זיהוי ביומטרי אינו נתמך במכשיר זה",
    manageNotifications: "ניהול התראות",
    whatsNew: "מה חדש?",
    noUpdates: "אין עדכונים חדשים",
    logout: "התנתקות",
    loggedInAs: "מחובר כ",
    // User navigation
    insights: "דרכים לייעול",
    assetsAndLiabilities: "נכסים והתחייבויות",
    cashflow: "תזרים",
    opportunities: "הזדמנויות",
    dashboard: "דאשבורד",
    insurance: "ביטוחים",
    retirement: "פרישה",
    advancedRetirement: "תכנון",
    benchmarks: "מדד הפראייר",
    // Planner navigation
    manageClients: "ניהול לקוחות",
    editInsights: "עריכת תובנות",
    manageMasleka: "ניהול מסלקה",
    accountManagement: "ניהול חשבון",
    resources: "משאבים",
    // Agency navigation
    manageAgents: "ניהול סוכנים",
    // Affiliator navigation
    affiliatorDashboard: "לוח בקרה",
    affiliatorPayments: "תשלומים",
    affiliatorSources: "מקורות",
    affiliatorInsights: "ניהול תובנות",
    // Admin navigation
    adminUsersAndAffiliates: "ניהול משתמשים",
    adminDashboard: "לוח בקרה",
    adminYuvalNumbers: "Yuval's Numbers",
    adminAffiliates: "שותפים",
    adminPlanners: "מתכננים",
    adminInsightApproval: "אישור תובנות",
    adminPayments: "תשלומים",
    adminActivityLog: "יומן פעילות",
    adminMessaging: "שליחת מיילים, WhatsApp והתראות",
    adminAnnouncements: "הכרזות ועדכוני מוצר",
    adminCRM: "CRM",
    adminInsightManagement: "ניהול תובנות",
    adminOpportunityManagement: "ניהול הזדמנויות",
    adminOpenFinance: "בנקאות פתוחה",
    adminDbQuery: "שאילתת מסד נתונים",
    // Loading overlay
    loading: "טוען...",
    switchingLanguage: "מחליף שפה...",
    // Sidebar role tabs
    userTab: "משתמש",
    plannerTab: "מתכנן",
    agencyTab: "סוכנות",
    affiliatorTab: "שותף",
    adminTab: "ניהול",
  },
  ENG: {
    // Profile dropdown
    subscription: "Account management",
    contact: "Contact / Support",
    manageConnections: "Manage bank connections",
    familyAccount: "Family account",
    biometricSetup: "Set up biometric login",
    biometricManage: "Manage biometric login",
    biometricEnabled: "Biometric login enabled ✓",
    biometricModalTitle: "Manage biometric login",
    biometricAddDevice: "Add device",
    biometricRemove: "Remove",
    biometricThisDevice: "(this device)",
    biometricNoDevices: "No connected devices",
    biometricConfirmRemove: "Remove biometric login from this device?",
    biometricRegistering: "Registering...",
    biometricRegisterSuccess: "Biometric login has been set up for this device!",
    biometricNotSupported: "Biometric login is not supported on this device",
    manageNotifications: "Manage notifications",
    whatsNew: "What's new?",
    noUpdates: "No new updates",
    logout: "Sign out",
    loggedInAs: "Logged in as",
    // User navigation
    insights: "Insights",
    assetsAndLiabilities: "Assets & Liabilities",
    cashflow: "Cash Flow",
    opportunities: "Opportunities",
    dashboard: "Dashboard",
    insurance: "Insurance",
    retirement: "Retirement",
    advancedRetirement: "Advanced Retirement",
    benchmarks: "Freier Index",
    // Planner navigation
    manageClients: "Manage clients",
    editInsights: "Edit insights",
    manageMasleka: "Manage Masleka",
    accountManagement: "Account management",
    resources: "Resources",
    // Agency navigation
    manageAgents: "Manage agents",
    // Affiliator navigation
    affiliatorDashboard: "Dashboard",
    affiliatorPayments: "Payments",
    affiliatorSources: "Sources",
    affiliatorInsights: "Manage Insights",
    // Admin navigation
    adminUsersAndAffiliates: "User management",
    adminDashboard: "Dashboard",
    adminYuvalNumbers: "Yuval's Numbers",
    adminAffiliates: "Affiliates",
    adminPlanners: "Planners",
    adminInsightApproval: "Insight approval",
    adminPayments: "Payments",
    adminActivityLog: "Activity Log",
    adminMessaging: "Emails, WhatsApp and Push",
    adminAnnouncements: "Announcements",
    adminCRM: "CRM",
    adminInsightManagement: "Insight Management",
    adminOpportunityManagement: "Opportunity Management",
    adminOpenFinance: "Open Finance",
    adminDbQuery: "DB Query",
    // Loading overlay
    loading: "Loading...",
    switchingLanguage: "Switching language...",
    // Sidebar role tabs
    userTab: "User",
    plannerTab: "Planner",
    agencyTab: "Agency",
    affiliatorTab: "Affiliate",
    adminTab: "Admin",
  },
  RUS: {
    // Profile dropdown
    subscription: "Аккаунт",
    contact: "Связаться / Поддержка",
    manageConnections: "Банк и карты",
    familyAccount: "Семейный аккаунт",
    biometricSetup: "Настроить биометрический вход",
    biometricManage: "Биометрия",
    biometricEnabled: "Биометрический вход включён ✓",
    biometricModalTitle: "Биометрический вход",
    biometricAddDevice: "Добавить устройство",
    biometricRemove: "Удалить",
    biometricThisDevice: "(это устройство)",
    biometricNoDevices: "Нет подключённых устройств",
    biometricConfirmRemove: "Удалить биометрический вход с этого устройства?",
    biometricRegistering: "Регистрация...",
    biometricRegisterSuccess: "Биометрический вход успешно настроен для этого устройства!",
    biometricNotSupported: "Биометрический вход не поддерживается на этом устройстве",
    manageNotifications: "Уведомления",
    whatsNew: "Что нового?",
    noUpdates: "Нет новых обновлений",
    logout: "Выйти",
    loggedInAs: "Вы вошли как",
    // User navigation
    insights: "Рекомендации",
    assetsAndLiabilities: "Активы и обязательства",
    cashflow: "Денежный поток",
    opportunities: "Возможности",
    dashboard: "Дашборд",
    insurance: "Страхование",
    retirement: "Пенсия",
    advancedRetirement: "Калькулятор пенсии",
    benchmarks: "Индекс Фраера",
    // Planner navigation
    manageClients: "Клиенты",
    editInsights: "Рекомендации",
    manageMasleka: "Маслека",
    accountManagement: "Аккаунт",
    resources: "Ресурсы",
    // Agency navigation
    manageAgents: "Агенты",
    // Affiliator navigation
    affiliatorDashboard: "Панель управления",
    affiliatorPayments: "Платежи",
    affiliatorSources: "Источники",
    affiliatorInsights: "Рекомендации",
    // Admin navigation
    adminUsersAndAffiliates: "User management",
    adminDashboard: "Dashboard",
    adminYuvalNumbers: "Yuval's Numbers",
    adminAffiliates: "Affiliates",
    adminPlanners: "Planners",
    adminInsightApproval: "Insight approval",
    adminPayments: "Payments",
    adminActivityLog: "Activity Log",
    adminMessaging: "Email, WhatsApp и push",
    adminAnnouncements: "Анонсы",
    adminCRM: "CRM",
    adminInsightManagement: "Insight Management",
    adminOpportunityManagement: "Opportunity Management",
    adminOpenFinance: "Открытый банкинг",
    adminDbQuery: "Запрос к БД",
    // Loading overlay
    loading: "Загрузка...",
    switchingLanguage: "Смена языка...",
    // Sidebar role tabs
    userTab: "Профиль",
    plannerTab: "План",
    agencyTab: "Агентство",
    affiliatorTab: "Партнёр",
    adminTab: "Admin",
  },
};
